import React from 'react';
import Logo from '../../Assets/BugLogo.png';
import { Box, Typography } from '@mui/material';
import { useEffect } from 'react';
import axios from '../../api/appPublicApi';
import { useDispatch } from 'react-redux';
import { setUserInformation } from '../../Redux/UserInformationSlice';
import jwt_decode from 'jwt-decode';
import { setUserPermission } from '../../Redux/UserPermissionSlice';
import { useNavigate } from 'react-router-dom';

const Handshake = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const fetchUser = async () => {
      try {
        const response = await axios.post(`/api/app/loginhandshake`, {
          hash: token,
        });

        const decoded = jwt_decode(response.data.token);
        dispatch(
          setUserInformation({
            userID: decoded.user_id,
            contactID: decoded.contact_id,
            token: response.data.token,
            firstName: decoded.first_name,
            lastName: decoded.last_name,
            avatarLink: decoded.avatar_link,
            employeeNumber: decoded.employee_number,
          })
        );
        dispatch(setUserPermission(decoded.elements));
        navigate(`/${decoded.destination_path.split('/').pop()}`, { replace: true });
      } catch (error) {
        navigate('/login', { replace: true });
      }
    };
    if (token) {
      fetchUser();
    } else {
      navigate('/login', { replace: true });
    }
  }, [dispatch, navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <img src={Logo} alt='Logo' style={{ width: 500, height: 'auto', paddingTop: 55 }} />
      <Typography variant='h4' style={{ textAlign: 'center' }}>
        Logging in...
      </Typography>
    </Box>
  );
};

export default Handshake;
